import { render, staticRenderFns } from "./exhibition-service.vue?vue&type=template&id=1018ccc3&scoped=true&"
import script from "./exhibition-service.vue?vue&type=script&lang=js&"
export * from "./exhibition-service.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-service.vue?vue&type=style&index=0&id=1018ccc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018ccc3",
  null
  
)

export default component.exports